var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 176 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.32 97.98L107.2 136.86M107.2 97.98L68.32 136.86M10 39.66H165.52M126.64 39.66L124.01 31.768C121.46 24.1201 120.185 20.2962 117.821 17.469C115.733 14.9725 113.052 13.04 110.024 11.8489C106.593 10.5 102.564 10.5 94.5018 10.5H81.0182C72.9564 10.5 68.9265 10.5 65.4964 11.8489C62.4678 13.04 59.7866 14.9725 57.6989 17.469C55.3346 20.2962 54.06 24.1201 51.5106 31.768L48.88 39.66M146.08 39.66V138.804C146.08 155.136 146.08 163.3 142.902 169.539C140.106 175.026 135.646 179.486 130.159 182.282C123.92 185.46 115.756 185.46 99.424 185.46H76.096C59.7648 185.46 51.5993 185.46 45.3617 182.282C39.8748 179.486 35.4139 175.026 32.6182 169.539C29.44 163.3 29.44 155.136 29.44 138.804V39.66",
    stroke: "white",
    strokeWidth: 19.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e84b7920cd4e13a16139ea9095732c7d.svg";
export { ForwardRef as ReactComponent };